import React, { Component } from 'react';
import './DropdownSelectorMenu.css';
import CheckboxFilter from './CheckboxFilter';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import ParameterErrors from '../errors/ParameterErrors';
import stopEventPropagation from'../ui_core/stopEventPropagation';
const {throwNotProvided}=ParameterErrors;
export default class DropdownSelectorMenu {
	constructor(props){
		const {classNames, defaultTitle} = props;
		this._element = document.createElement('div');
		this._element.classList.add('dropdown-selector-menu');
		this._element.innerHTML = defaultTitle;
		this.showEntries = this.showEntries.bind(this);
		this.setEntries = this.setEntries.bind(this);
		this.hideEntries = this.hideEntries.bind(this);
		this._setExpandedClassName = this._setExpandedClassName.bind(this);
		this._element.addEventListener('click', this.showEntries)
		this._entriesElement = document.createElement('div');
		this._entriesElement.classList.add('entries');
		this._element.appendChild(this._entriesElement);
		if(classNames){
			if(Array.isArray(classNames))
				classNames.forEach(className=>this._element.classList.add(className));
			else 
				this._element.classList.add(classNames);
		}
		this._clickedOffHandle = null;
		this._clickedOffManager = new ClickedOffManager({element:this._entriesElement, hide:
			this.hideEntries});
	}
	showEntries(){
		this._setExpandedClassName(true);
		this._clickedOffManager.register();
	}
	_setExpandedClassName(value){
		if(value)
			this._element.classList.add('expanded');
		else 
			this._element.classList.remove('expanded');
	}
	get element(){
		return this._element;
	}
	setEntries(entries){
		this._entries?.forEach(entry=>this._entriesElement.removeChild(entry.element));
		this._entries =[];
		entries.forEach(entry=>{
			const {callback, value, text, classNames}= entry;
			const entryElement = document.createElement('div');
			this._entriesElement.appendChild(entryElement);
			entryElement.innerHTML = text;
			entryElement.classList.add('entry');
			if(classNames){
				if(Array.isArray(classNames))
					classNames.forEach(className=>entryElement.classList.add(className));
				else entryElement.classList.add(classNames);
			}
			if(callback){
				entryElement.addEventListener('click', (e)=>{
					e.value = value;
					this.hideEntries();
					callback(e);
				});
			}
			stopEventPropagation(entryElement, [ 'touchstart', 'click', 'mousedown' ]);
			this._entries.push({entryElement, callback, value});
		});
	}
	hideEntries(){
		this._clickedOffManager.dispose();
		this._setExpandedClassName(false);
	}
}
